import { render, staticRenderFns } from "./AskOrganiserRoute.vue?vue&type=template&id=00a55ab3&"
import script from "./AskOrganiserRoute.vue?vue&type=script&lang=ts&"
export * from "./AskOrganiserRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports